<!DOCTYPE html>
@if (route.children.length === 0 && !exporting) {
  @if (!showEnvironments && !showImportSolution) {
    <app-datatable [identifier]="'settings-solutions-table'" [title]="title" [cols]="cols"
      [rows]="rows" [pagination]="true" [total]="total" [showaddicon]="canAddSolution" [showdragdrop]="canImport"
      [filters]="filters" [isloading]="loading" [currentPage]="currentPage" [showcheckboxes]="true" [overrideShowError]="true"
      (actionmenuevent)="solutionActionMenuClicked($event)"
      (pageevent)="onPageChange($event)" (onclickheaderadd)="showAddSolutionDialog()"
      (onclickcolumn)="sortSolutions($event)" (onclickdragdrop)="onImportClick()" (onchangefilter)="onFilterChanged($event)"
    ></app-datatable>
  }
  @if (showEnvironments) {
    <div id="environments-view" class="ot-panel">
      <div class="ot-panel__header">
        <div role="group" class="ot-btn-group">
          <button id='back-to-solutions-button' class="ot-btn ot-btn--is-transparent ot-btn--icon-only ot-icon ot-icon--is-24x24"
            (click)="backToSolutions()" aria-label="Back">
            <img src="./assets/icons/circle_arrow_back18.svg" alt="Back" />
          </button>
        </div>
      </div>
      <div class="ot-row ot-pl-1 ot-pr-1">
        <div class="ot-row__column">
          <small class="ot--has-text-muted" i18n>Name</small>
          <p id="product-updates-name">
          {{selectedSolution.name}}</p>
        </div>
        <div class="ot-row__column">
          <small class="ot--has-text-muted" i18n>Description</small>
          <p id="product-updates-description">
          {{selectedSolution.description}}</p>
        </div>
        <div class="ot-row__column">
          <small class="ot--has-text-muted" i18n>Created By</small>
          <p id="product-updates-size">{{selectedSolution.createdBy}}</p>
        </div>
        <div class="ot-row__column">
          <small class="ot--has-text-muted" i18n>Created date</small>
          <p id="product-updates-release-date">
          {{selectedSolution.createdDate | date:'LLL d, yyyy'}}</p>
        </div>
      </div>
      <div class="env-table-container">
        <app-datatable [identifier]="'settings-solutions-environments-table'" [title]="envTitle"
          [cols]="envCols" [rows]="envRows" [total]="total" [showaddicon]="canAddEnv"
          [filters]="filters" [isloading]="loading" [showcheckboxes]="true" [overrideShowError]="true"
          (actionmenuevent)="environmentActionMenuClicked($event)"
          (pageevent)="onPageChange($event, FormObjectType.ENVIRONMENT)"
          (onclickcolumn)="sortEnvironments($event)"
        (onclickheaderadd)="showAddEnvironmentDialog()"></app-datatable>
      </div>
    </div>
  }
  @if (showImportSolution) {
    <app-import-solution-form [data]="importData" (close)="onImportFormClose($event)"></app-import-solution-form>
  }
}
@if (exporting) {
  <div id="solution-exporting" class="ot-progress ot-progress--is-spinner ot-progress--is-spinner-has-text">
    <div class="ot-progress__outer">
      <div class="ot-progress__meter">
      </div>
    </div>
    <div class="ot-progress__text" i18n>Generating solution package. Please wait...</div>
  </div>
}
<router-outlet></router-outlet>